const baseUrl="http://localhost:3000/"
const textBoxStrLength=500;

module.exports={
    baseUrl,
    textBoxStrLength
}